import { Mountain, Play, X } from "lucide-react";
import { useLang } from "@/i18n";

const base = `${process.env.PUBLIC_URL || ""}/game-assets`;

// Shown after beating Cerro Negro: offers the Volcano Boarding bonus with a
// Play / Skip choice before the bonus round starts.
export default function BonusPrompt({ onPlay, onSkip }) {
  const { t } = useLang();
  return (
    <div className="absolute inset-0 z-[70] overflow-y-auto"
      style={{ background: "radial-gradient(ellipse at 50% 35%, #3a1f12 0%, #0a0a14 78%)" }}
      data-testid="bonus-prompt">
      <div className="min-h-full flex flex-col items-center justify-center p-4 py-8">
        <div className="relative flex flex-col items-center text-center pixel-card bg-[#141414]/95 max-w-sm w-full p-5 nb-pop">
          <span className="text-3xl mb-1">🌋</span>
          <h2 className="font-pixel text-base md:text-lg text-[#FFB300] pixel-stroke leading-tight" data-testid="bonus-prompt-title">
            {t("bonusPromptTitle")}
          </h2>
          <p className="font-vt text-white/85 text-sm md:text-base mt-1.5 leading-snug">{t("bonusPromptBody")}</p>

          <div className="flex flex-col gap-2 w-full mt-4">
            <button data-testid="bonus-prompt-play-btn" onClick={onPlay}
              className="pixel-btn bg-[#FF5722] text-white w-full py-3 text-sm blink flex items-center justify-center gap-2">
              <Play size={16} strokeWidth={2.5} fill="#fff" /> {t("bonusPlay")}
            </button>
            <button data-testid="bonus-prompt-skip-btn" onClick={onSkip}
              className="pixel-btn bg-[#222] text-white w-full py-2.5 text-xs flex items-center justify-center gap-2">
              <X size={15} strokeWidth={2.5} /> {t("bonusSkip")}
            </button>
          </div>
          <Mountain size={14} className="text-white/30 mt-3" />
        </div>
      </div>
    </div>
  );
}
